import { createRouter, createMemoryHistory } from 'vue-router';
import LoginView from './views/LoginView';
import RegisterView from './views/RegisterView';
import PasswordResetView from './views/PasswordResetView';
import RegisterPlanSelectView from './views/RegisterPlanSelectView';
import RegisterPlanSelectCreditsView from './views/RegisterPlanSelectCreditsView';
import RegisterProductSelectSuggestionView from './views/RegisterProductSelectSuggestionView';
import RegisterChooseBillingView from './views/RegisterChooseBillingView';
import RegisterChoosePaymentView from './views/RegisterChoosePaymentView';
import RegisterPaymentSuccessView from './views/RegisterPaymentSuccessView';
import RegisterConfirmationEmailSentView from './views/RegisterConfirmationEmailSentView';
import RegisterPlanSelectConversionMinutesView from './views/RegisterPlanSelectConversionMinutesView';
import ContactUsForm from '../../../../qaamgo/modules/sat/components/ContactUsForm';
import RegisterAccountCreatedView from './views/RegisterAccountCreatedView.vue';
import ClaimEducationView from './views/ClaimEducationView.vue';

const userModalRoute = {
    LOGIN: 'login',
    REGISTER: 'register',
    PASSWORD_RESET: 'password-reset',
    REGISTER_PLAN_SELECT: 'register-plan-select',
    REGISTER_PLAN_CREDITS_SELECT: 'register-plan-credits-select',
    REGISTER_PLAN_SELECT_CONVERSION_MINUTES: 'register-plan-select-conversion-minutes',
    REGISTER_PRODUCT_CREDITS_SELECT: 'register-product-credits-select',
    REGISTER_CHOOSE_BILLING: 'register-choose-billing',
    REGISTER_CHOOSE_PAYMENT: 'register-choose-payment',
    REGISTER_PAYMENT_SUCCESS: 'register-payment-success',
    REGISTER_CONFIRMATION_MAIL_SENT: 'register-confirmation-mail-sent',
    REGISTER_ACCOUNT_CREATED: 'register-account-created',
    CONTACT_US_FORM: 'contact-us-form',
    CLAIM_EDUCATION: 'claim-education',
};

export { userModalRoute };

const userModalRouter = new createRouter({
    history: createMemoryHistory(),
    routes: [
        {
            path: '/login',
            name: userModalRoute.LOGIN,
            component: LoginView,
            props: true,
        },
        {
            path: '/claim-education',
            name: userModalRoute.CLAIM_EDUCATION,
            component: ClaimEducationView,
            props: true,
        },
        {
            path: '/register',
            name: userModalRoute.REGISTER,
            component: RegisterView,
        },
        {
            path: '/register-plan-select',
            name: userModalRoute.REGISTER_PLAN_SELECT,
            component: RegisterPlanSelectView,
        },
        {
            path: '/register-plan-credits-select',
            name: userModalRoute.REGISTER_PLAN_CREDITS_SELECT,
            component: RegisterPlanSelectCreditsView,
        },
        {
            path: '/register-plan-select-conversion-minutes',
            name: userModalRoute.REGISTER_PLAN_SELECT_CONVERSION_MINUTES,
            component: RegisterPlanSelectConversionMinutesView,
            props: true,
        },
        {
            path: '/register-product-credits-select',
            name: userModalRoute.REGISTER_PRODUCT_CREDITS_SELECT,
            component: RegisterProductSelectSuggestionView,
        },
        {
            path: '/register-choose-billing',
            name: userModalRoute.REGISTER_CHOOSE_BILLING,
            component: RegisterChooseBillingView,
        },
        {
            path: '/register-choose-payment',
            name: userModalRoute.REGISTER_CHOOSE_PAYMENT,
            component: RegisterChoosePaymentView,
        },
        {
            path: '/password-reset',
            name: userModalRoute.PASSWORD_RESET,
            component: PasswordResetView,
        },
        {
            path: '/register-payment-success',
            name: userModalRoute.REGISTER_PAYMENT_SUCCESS,
            component: RegisterPaymentSuccessView,
            props: true,
        },
        {
            path: '/register-confirmation-mail-sent',
            name: userModalRoute.REGISTER_CONFIRMATION_MAIL_SENT,
            component: RegisterConfirmationEmailSentView,
            props: true,
        },
        {
            path: '/register-account-created',
            name: userModalRoute.REGISTER_ACCOUNT_CREATED,
            component: RegisterAccountCreatedView,
            props: true,
        },
        {
            path: '/contact-us/:defaultQuestionType?',
            name: userModalRoute.CONTACT_US_FORM,
            component: ContactUsForm,
            props: true,
        },
    ],
});

export { userModalRouter };
